import { render, staticRenderFns } from "./PredictionHistory.vue?vue&type=template&id=a5a0e05a"
import script from "./PredictionHistory.vue?vue&type=script&lang=js"
export * from "./PredictionHistory.vue?vue&type=script&lang=js"
import style0 from "./PredictionHistory.vue?vue&type=style&index=0&id=a5a0e05a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports